<template>
  <div>
    <!-- Integrations Grid -->
    <Section>
      <IntegrationsGrid />
    </Section>

    <!-- CTA Section -->
    <Section>
      <div class="text-center max-w-3xl mx-auto">
        <h2 class="text-3xl font-bold text-ink mb-4">
          Need a Custom Integration?
        </h2>
        <p class="text-lg text-muted mb-8">
          We're constantly adding new marketplace integrations. Let us know which platforms you need.
        </p>
        <BaseButton variant="primary" size="lg">
          {{ $t('common.requestDemo') }}
        </BaseButton>
      </div>
    </Section>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@vueuse/head'
import { useI18n } from 'vue-i18n'
import Section from '@/components/Section.vue'
import BaseButton from '@/components/BaseButton.vue'
import IntegrationsGrid from '@/components/IntegrationsGrid.vue'

const { t } = useI18n()

useHead({
  title: () => `${t('integrations.title')} - E2M`,
  meta: [
    { name: 'description', content: () => t('integrations.subtitle') },
    { property: 'og:title', content: () => `${t('integrations.title')} - E2M` },
    { property: 'og:description', content: () => t('integrations.subtitle') }
  ]
})
</script>